import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/layout/Layout";
import Dashboard from "@/pages/Dashboard";
import Candidates from "@/pages/Candidates";
import Requisitions from "@/pages/Requisitions";
import Employees from "@/pages/Employees";
import EmployeeProfile from "@/pages/EmployeeProfile";
import Reviews from "@/pages/Reviews";
import Attrition from "@/pages/Attrition";
import Concerns from "@/pages/Concerns";
import Compliance from "@/pages/Compliance";
import Schedule from "@/pages/Schedule";
import Goals from "@/pages/Goals";
import AIAssistant from "@/pages/AIAssistant";
import AuthVerify from "@/pages/AuthVerify";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--yc-bg)]">
        <div className="text-slate-500 label-eyebrow">Opening workspace…</div>
      </div>
    );
  }
  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--yc-bg)]">
        <div className="text-center">
          <div className="text-slate-600 text-sm">Could not connect to the workspace.</div>
          <button onClick={() => window.location.reload()} className="mt-3 text-sm underline text-[var(--yc-navy)]">Try again</button>
        </div>
      </div>
    );
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/verify" element={<AuthVerify />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="candidates" element={<Candidates />} />
              <Route path="requisitions" element={<Requisitions />} />
              <Route path="employees" element={<Employees />} />
              <Route path="employees/:id" element={<EmployeeProfile />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="attrition" element={<Attrition />} />
              <Route path="concerns" element={<Concerns />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="goals" element={<Goals />} />
              <Route path="settings" element={<Settings />} />
              <Route path="ai" element={<AIAssistant />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
